/**
  Converting object structure
 **/
export const getISOFormatDateFromObject = (date) => {
  const { day, month, year } = date
  return `${year}-${(month).toString().padStart(2, '0')}-${(day).toString().padStart(2, '0')}`
}
